import { LiveChatWidget } from '@livechat/widget-react';

const LiveChatComponent = () => {
  // TODO do not hardcode that!!
  return <LiveChatWidget license="10585752" />;
};

export default LiveChatComponent;
